import { Currency } from "./currency.type";
import { Partenrs } from "./investment.type";

export enum WithdrawalType {
  PROFIT = "Прибыль",
  INVESTMENT = "Инвестиция",
}

export interface Withdrawal extends Document {
  type: WithdrawalType;
  _id: string;
  cashboxId: string;
  cashboxName:string;
  amount: number;
  currency: Currency;
  date: string;
  description?: string;
  userId: string;
  username: string;
  partnerId: string;
  partnerName: string;
  refPartnerId: string;
  refPartnerName: string;
}
